import type { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Prepends the conduct API origin to relative requests (starting with `/`). The generated clients
 * call relative paths. Runs before `spinoffAuthInterceptor`, which only attaches tokens to URLs
 * under the API origin.
 */
export const conductApiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/')) {
    return next(req);
  }

  return next(req.clone({ url: `${environment.conductApiBaseUrl}${req.url}` }));
};
